import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import {EmployeeService} from "../../../../services/employee.service";
import {environment} from "../../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";

import * as XLSX from "xlsx";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {
    FollowUpQuestionComponent
} from "../../../counseling/components/follow-up-question/follow-up-question.component";
import {
    ViewFollowUpAssessmentComponent
} from "../../../counseling/components/follow-up-question/view-follow-up-assessment/view-follow-up-assessment.component";
import {FullChild} from "../../../../interfaces/FullChild";
import {ChildService} from "../../../../components/child/child.service";
import firebase from "firebase/compat/app";


@Component({
  selector: 'app-followup-sessions-overview',
  templateUrl: './followup-sessions-overview.component.html',
  styleUrls: ['./followup-sessions-overview.component.scss']
})
export class FollowupSessionsOverviewComponent  implements OnInit, OnDestroy {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    private _destroyed$ = new Subject<void>();
    counsellors$: Observable<any[]>
    submittedBy: string | undefined | null = null
    mData:any[]=[]
    dataSource: any
    startDate: Date | undefined
    endDate: Date | undefined
    displayedColumns: string[] = ['children', 'centre', 'dateOfAssessment', 'action'];
    centres$: Observable<Centre[]>
    selectedCentre: Centre | undefined
    children$:Observable<FullChild[]>|undefined
selectedChild:FullChild|undefined
    constructor(private mFirestore: AngularFirestore,
                private readonly mSnackbar: MatSnackBar,
                private readonly mCentreService: CentreService,
                private readonly mChildService: ChildService,

                private readonly mEmployeeService: EmployeeService,
                private matDialog: MatDialog) {
        this.centres$ = this.mCentreService.getAllCentres().pipe(
          map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        )
        this.counsellors$ = this.mEmployeeService.getCounsellers()

    }

    clearAll(): void {
        this.startDate = undefined;
        this.endDate = undefined;
        this.selectedCentre = undefined;
        this.dataSource.data = [];
    }
    ngOnInit(): void {
        this.mFirestore.collection(this.env.counsellingFollowUp).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res => {
            this.mData= res
            this.dataSource = new MatTableDataSource(this.mData)
        })
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    search() {
        if (this.selectedCentre && this.selectedChild) {
            this.mFirestore.collection(this.env.counsellingFollowUp, ref => ref.where('centreCode', '==', this.selectedCentre!.centreCode)
                .where('childCode','==',this.selectedChild?.childCode)).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res => {
                let d = res
                if (this.startDate != undefined && this.endDate != undefined) {

                    // @ts-ignore
                    d = res.filter((x) => x.dateOfAssessment!!.toDate()!! >= this.startDate!! && x.dateOfAssessment!!.toDate()!! <= this.endDate!!)
                }
                this.mData =d
                this.dataSource = new MatTableDataSource(this.mData)

            })
        } else {
            this.mSnackbar.open('Select a centre first', "", {
                duration: 4000,
                panelClass: 'error'
            })
        }
    }


    deleteChild(element: any) {
        this.mFirestore.collection(this.env.counsellingFollowUp).doc(element.id).delete().then(r => {
            console.log("Deleted successfully")
        })

    }

    viewEdit(element: any) {
        this.matDialog.open(FollowUpQuestionComponent, {
                data: element,
                autoFocus: false,
                width: '800%',
                height: '90%'
            }
        )
    }

    OpenDialog() {
        this.matDialog.open(FollowUpQuestionComponent, {
            autoFocus: false,
            width: '800%',
            height: '90%'
        })
    }

    //
    // search() {
    //     this.mFirestore.collection(this.env.counsellingFollowUp).valueChanges({idField:'id'}).subscribe(res => {
    //         this.dataSource = res
    //     })
    // }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;

        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    viewDialog(element:any) {
        this.matDialog.open(ViewFollowUpAssessmentComponent, {
            autoFocus: false,
            width: '800%',
            height: '90%',
            data: element
        })

    }
    applyfilters() {
        this.dataSource.data=this.mData
        if (this.dataSource.data.length >= 1) {
            if (this.submittedBy!=null) {
                // alert('filttering')
                this.dataSource.data = this.mData.filter((x:any )=> x.submittedBy == this.submittedBy)
            }


        }
    }
onCentreSelected(){
     if(this.selectedCentre)   this.children$  =this.mChildService.getAllotedChildListByCenter(this.selectedCentre?.centreCode)
}

}
